var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1ChevronArrowD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.77 37L38 55.4 56.23 37 59 39.8 38 61 17 39.8l2.77-2.8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.77 14L38 32.4 56.23 14 59 16.8 38 38 17 16.8l2.77-2.8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Chevron_arrow_D.c252b3ce.svg";
export { SvgJ1ChevronArrowD as ReactComponent };